var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data-share_svg__clip0_61530_7394)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.75v-6.879l-2.69 2.69L0 13.5 4.5 9 9 13.5l-1.06 1.06-2.69-2.689v6.879h9v1.5h-9a1.502 1.502 0 01-1.5-1.5zM18 16.5h3a1.502 1.502 0 011.5 1.5v3a1.502 1.502 0 01-1.5 1.5h-3a1.502 1.502 0 01-1.5-1.5v-3a1.502 1.502 0 011.5-1.5zm3 4.5v-3h-3.001L18 21h3zM20.25 4.5v6.879l2.69-2.69L24 9.75l-4.5 4.5-4.5-4.5 1.06-1.06 2.69 2.689V4.5h-9V3h9a1.502 1.502 0 011.5 1.5zM6 4.5H1.5V6H6V4.5zM7.5 1.5h-6V3h6V1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data-share_svg__clip0_61530_7394"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDataShare;